export const RawCheUIDRegex = new RegExp(/^CHE[-.]?(\d{3})[-.]?(\d{3})[-.]?(\d{3})[-.]?(\d{0,3})$/);
export type CheUID = `CHE${number}`;
export type RawCheUID =
  CheUID | `CHE-${number}.${number}.${number}` | `CHE-${number}.${number}.${number}.${number}`;
export const isRawCheUID = (value: string): value is RawCheUID => RawCheUIDRegex.test(value);
export const cleanCheUID = (value: RawCheUID): CheUID => value.replace(/[-.]/g, '') as CheUID;
export const formatCheUID = (value: CheUID) =>
  value.replace(RawCheUIDRegex, (_, p1, p2, p3, p4) =>
    p4 ? `CHE.${p1}-${p2}-${p3}-${p4}` : `CHE.${p1}-${p2}-${p3}`
  );
